import "./ScrollableNode.css";

import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";

import { type CustomNodeTypes, type NodeData } from "../../types";
import { NodeItem } from "../NodeItem";

type ScrollableNodeProps = Node<{
  list: NodeData[];
  isLeftNode: boolean;
  type: CustomNodeTypes;
  styles: React.CSSProperties;
  usesRelationship: boolean;
}>;

export default function ScrollableNode({
  data,
}: NodeProps<ScrollableNodeProps>) {
  const { list = [], isLeftNode, styles = {}, usesRelationship = false } = data;

  const nodeClassName =
    list.length > 1 ? (isLeftNode ? "left-node" : "right-node") : "";

  return (
    <div
      className={`Nhi-AccessMap-scrollable-node nowheel ${list.length > 4 ? "" : "no-bottom-border"} ${
        list.length > 1
          ? `border-padding ${
              isLeftNode ? "left-node-border" : "right-node-border"
            }`
          : ""
      } ${usesRelationship ? "blue" : "gray"}`}
      style={styles}
    >
      {list.map((d) => (
        <div
          key={d.label + d.displayName}
          className={`node ${d.usesRelationship ? "blue" : "gray"} ${
            nodeClassName
          }`}
        >
          <NodeItem
            data={d}
            isLeftNode={isLeftNode}
            type={`${d.label}s` as CustomNodeTypes}
          />
        </div>
      ))}

      {!isLeftNode ? (
        <Handle type="target" position={Position.Left} />
      ) : (
        <Handle type="source" position={Position.Right} />
      )}
    </div>
  );
}
